import {adminRequest, requireData} from './adminRequest';
import {adminTagEndpoint, adminTagsEndpoint} from '../constants/endpoints';

export interface AdminTag {
  code: number;
  name: string;
  categoryCode: number;
  categoryName?: string | null;
  isForGoogleSearch: boolean;
  placeCount: number;
  eventCount: number;
  userCount: number;
  // Vibes and activity times that expand into this tag, e.g. "Vibe: Social".
  linkedTo: string[];
  usedByTripPlanner: boolean;
  // Set when the tag cannot be deleted.
  deleteBlockedReason?: string | null;
}

export interface AdminCategory {
  code: number;
  name: string;
}

export interface AdminTags {
  tags: AdminTag[];
  categories: AdminCategory[];
  remainingCodes: number;
}

export interface CreateTagInput {
  name: string;
  categoryCode: number;
  isForGoogleSearch: boolean;
}

export interface DeleteTagResult {
  code: number;
  name: string;
  vectorsCleared: number;
}

export const fetchAdminTags = async (): Promise<AdminTags> =>
  requireData(
    await adminRequest<AdminTags>(
      {endpoint: adminTagsEndpoint, method: 'GET'},
      'Failed to fetch tags',
    ),
    'Failed to fetch tags',
  );

export const createTag = async (input: CreateTagInput): Promise<AdminTag> =>
  requireData(
    await adminRequest<AdminTag, CreateTagInput>(
      {endpoint: adminTagsEndpoint, method: 'POST', body: input},
      'Failed to create the tag',
    ),
    'Failed to create the tag',
  );

export const deleteTag = async (code: number): Promise<DeleteTagResult> =>
  requireData(
    await adminRequest<DeleteTagResult>(
      {endpoint: adminTagEndpoint(code), method: 'DELETE'},
      'Failed to delete the tag',
    ),
    'Failed to delete the tag',
  );
